import styled from '@emotion/styled'

import { BorderRadius } from '../../enums/borderRadius'
import { Spacing } from '../../enums/spacing'
import { SectionMessageVariant } from './types'
import { variantStyles } from './utils'

interface SectionMessageProps {
  variant: SectionMessageVariant
}

export const SectionMessage = styled.section<SectionMessageProps>`
  display: flex;
  padding: ${Spacing.S12} ${Spacing.S16};
  border-radius: ${BorderRadius.R12};
  background-color: ${({ variant }) => variantStyles[variant].bgColor};
  color: ${({ variant }) => variantStyles[variant].color};
`

interface IconWrapperProps {
  hasTitle: boolean
}

export const IconWrapper = styled.div<IconWrapperProps>`
  display: flex;
  margin-top: ${({ hasTitle }) => (hasTitle ? Spacing.S8 : Spacing.S6)};
  margin-right: ${Spacing.S8};
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-top: ${Spacing.S4};
  margin-bottom: ${Spacing.S4};
`

export const Header = styled.header``

export const IconButtonWrapper = styled.div`
  margin-left: ${Spacing.S8};
`

export const TextWrapper = styled.div``

export const SideActionsWrapper = styled.div`
  margin-top: ${Spacing.S16};
`
